import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=73046326&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
import style0 from "./Auth.vue?vue&type=style&index=0&id=73046326&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73046326",
  null
  
)

export default component.exports